import { createIcon } from '@chakra-ui/react';

export const chatwootIcon = createIcon({
  displayName: 'chatwootIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        xmlns='http://www.w3.org/2000/svg'
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#009de0'
      />
      <path
        xmlns='http://www.w3.org/2000/svg'
        d='M17.1256 17.1258H11.5622C8.4955 17.1258 5.99976 14.6299 5.99976 11.5624C5.99976 8.49591 8.4955 6 11.5623 6C14.6298 6 17.1256 8.49591 17.1256 11.5624V17.1258Z'
        fill='white'
        stroke='white'
        stroke-width='0.28125'
      />
    </>
  ),
});
